// extracted by mini-css-extract-plugin
export var aiStarIcon = "_m4-2";
export var container = "_m4-4";
export var dismissButton = "_m4-3";
export var hasPaddingBottom = "_m4-6";
export var last = "_m4-e";
export var scrollbarThumb = "_m4-c";
export var scrollbarTrack = "_m4-b";
export var selected = "_m4-9";
export var spin = "_m4-1";
export var spinning = "_m4-0";
export var suggestionItem = "_m4-d";
export var suggestionsPanel = "_m4-5";
export var tonePill = "_m4-8";
export var tonesContainer = "_m4-7";
export var unselected = "_m4-a";